module.exports = __webpack_public_path__ + "img/Contact-Salessheet-blue.svg";


//////////////////
// WEBPACK FOOTER
// ./img/Contact-Salessheet-blue.svg
// module id = 244
// module chunks = 0